<template>
    <!--        v-click-outside="closeAddEditRuleDialog"-->
    <v-dialog
        v-model="addEditRuleDialogHandle"
        transition="dialog-bottom-transition"
        max-width="600px"
        @keydown.esc="closeAddEditRuleDialog()"
        @click:outside="closeAddEditRuleDialog()"
    >
        <v-card>
            <v-form @submit.prevent.native="addEditARule()">
                <v-toolbar
                    color="primary"
                    dark
                    :class="dialogHeadingClasses()"
                >
                    <v-icon v-text="icons.mdiPlusCircleOutline" class="mr-3" v-if="$props.mode === 'add'"></v-icon>
                    <v-icon v-text="icons.mdiPencilCircleOutline" class="mr-3" v-else></v-icon>
                    <div v-text="$gettext('Add Rule')" v-if="$props.mode === 'add'"></div>
                    <div v-text="$gettext('Edit Rule')" v-if="$props.mode === 'edit'"></div>
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" @click.native.stop="closeAddEditRuleDialog()" v-text="icons.mdiClose"></v-icon>
                    <v-icon @click.native.stop="addEditARule()" v-text="icons.mdiContentSave"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-8">
                    <v-container>
                        <v-row>

                            <v-col
                                cols="12"
                            >
                                <v-text-field
                                    :label="$gettext('Rule Name')"
                                    required
                                    :placeholder="$gettext('Rule Name')"
                                    v-model="addEditRuleName"
                                    :error-messages="addEditRuleNameErrors"
                                    outlined
                                    @input="$v.addEditRuleName.$touch()"
                                    @blur="$v.addEditRuleName.$touch()"
                                    autofocus
                                    clearable
                                ></v-text-field>
                            </v-col>

                        </v-row>
                    </v-container>

                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn color="primary"
                           @click.native.stop="closeAddEditRuleDialog()"
                    >
                        {{ $gettext('Close') }}
                    </v-btn>
                    <v-btn color="primary" type="submit">
                        {{ $gettext('Save') }}
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>


<script>

import { required } from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinVuelidate from '@/mixins/MixinVuelidate'

export default {
    components: { Snackbar },
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinVuelidate],
    props: {
        rulesProp: {
            required: true,
            type: Array | Object
        },
        addEditRuleDialog: {
            required: true,
            type: Boolean,
            default: false
        },
        mode: {
            type: String, // Expected: add/edit
            required: true,
            default: '',
        },
        inEditRuleName: {
            required: false,
            default: ''
        },

        /* currentSelectedRule: {
            required: true,
            default: ''
        }, */
    },
    data () {
        return {

            addEditRuleName: '',
            addEditRuleDialogHandle: '',
            // addRuleAnyUser: '',
            // addRuleAllowDeny: '',
            // addRuleAnyDestination: '',

        }
    },
    watch: {
        /**
         * When a popup is closed, the previous entry is left as is.
         * Also, when a popup is opened with other entry the value is not refreshed, with the new one, if we don't have this.
         * @param newVal
         */
        addEditRuleDialog (newVal) {

            let self = this

            if ( ! newVal) {
                self.resetForm()
            } else {
                self.addEditRuleName = self.$props.inEditRuleName

            }

        }
    },

    mounted () {
        let self = this

        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        self.addEditRuleName = self.$props.inEditRuleName
        self.addEditRuleDialogHandle = self.$props.addEditRuleDialog

    },

    methods: {

        async addEditARule () {

            let self = this
            self.$v.$touch()
            await self.$v.$invalid
            await self.$nextTick()
            await self.$nextTick() // safety net

            setTimeout(() => {
                if ( ! self.$v.$invalid) {

                    if (self.$props.mode === 'add') {

                        self.$emit('rule-added', {
                            key: self.addEditRuleName,
                            value: {
                                any_user: 0,
                                any_destination: 0,
                                allow_deny: 1,
                                active: 'on',
                                time_condition: '',
                                comments: '',
                                users: [],
                                dest_groups: [],
                                dest_domains: [],
                                strict_end: 0,
                            }
                        })
                    } else {
                        self.$emit('rule-updated', self.addEditRuleName)
                    }

                    self.closeAddEditRuleDialog()
                    self.resetForm()

                }

            }, 100)

        },

        closeAddEditRuleDialog () {
            let self = this
            self.$emit('close-add-edit-rule-dialog', 'addEditRuleDialog')
        },
        resetForm () {
            let self = this
            self.addEditRuleName = ''
            self.$v.$reset()
        },
    },
    computed: {

        addEditRuleNameErrors () {
            const errors = []
            if ( ! this.$v.addEditRuleName.$dirty) return errors
            ! this.$v.addEditRuleName.required && errors.push(this.$gettext('Rule name is required.'))
            ! this.$v.addEditRuleName.isUnique && errors.push(this.$gettext('We already have this rule name with us.'))
            return errors
        }

    },
    validations: {
        addEditRuleName: {
            required,
            async isUnique (value, vm) {
                let allowedValue = vm.mode === 'edit' ? vm.$props.inEditRuleName : null
                return await this.vuelidateIsUniqueForKeyValueType(value, this.$props.rulesProp, allowedValue)
            }
        }
    }

}
</script>

<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>
